import React from 'react'
import Grid from '../layout/grid'

export default props => {

	if (props.onChange) {
		return (
			<Grid cols={props.cols} style={{ minWidth: props.minWidth, maxWidth: props.maxWidth, marginTop: 16, marginBottom: 8 }}>
		        <div className='form-group checkbox'>
		            <label htmlFor={props.name} 
						style={{
							...props.style,
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
							cursor: 'pointer',
							fontWeight: 600
						}}>
						<input {...props}
			                 placeholder={props.placeholder}
			                 readOnly={props.readOnly}
							 type='checkbox'
							 style={{
								width: 18,
								height: 18,
								cursor: 'pointer'
							 }}
							 checked={props.value == true}
							 onChange={data => props.onChange(props.value ? false : true)} />
						{` ${props.label}`}
					</label>
		        </div>
		    </Grid>
		);
	} else {
		return (
			<Grid cols={props.cols} style={{ minWidth: props.minWidth, maxWidth: props.maxWidth, marginTop: 16, marginBottom: 16 }}>
		        <div className='form-group checkbox'>
		            <label htmlFor={props.name}
						style={{
							...props.style,
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
							cursor: 'pointer',
							fontWeight: 600
						}} >
						<input {...props.input}
			                 placeholder={props.placeholder}
			                 readOnly={props.readOnly} type='checkbox' checked={props.input.value == true}
							 style={{
								width: 18,
								height: 18,
								cursor: 'pointer'
							 }} />
						{` ${props.label}`}
					</label>
		        </div>
		    </Grid>
		);
	}
}
